import { render, staticRenderFns } from "./IngredientsContain.vue?vue&type=template&id=118b62e4&scoped=true&"
import script from "./IngredientsContain.vue?vue&type=script&lang=js&"
export * from "./IngredientsContain.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsContain.vue?vue&type=style&index=0&id=118b62e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b62e4",
  null
  
)

export default component.exports